package com.eladfinish.bible.contest.screens.settings.debug

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.material.icons.Icons
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Switch
import androidx.compose.material3.SwitchDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.style.TextDirection
import androidx.compose.ui.unit.dp
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.colorAccent
import com.eladfinish.bible.contest.di.getKoinInstance
import com.eladfinish.bible.contest.ui.components.mouseVerticalScrollbar
import com.eladfinish.bible.contest.ui.extensions.navigationBarContentPadding
import com.eladfinish.bible.contest.ui.icons.AppIcons
import dev.icerock.moko.resources.compose.colorResource

const val DEBUG_FLAGS_TITLE = "דגלי Debug"

@Composable
internal fun DebugFlagsScreen(
    repository: DebugFlagsRepository = getKoinInstance(),
) {
    var states by remember { mutableStateOf(repository.states()) }
    val refresh = { states = repository.states() }

    val listState = rememberLazyListState()

    LazyColumn(
        state = listState,
        modifier = Modifier
            .fillMaxSize()
            .mouseVerticalScrollbar(listState),
        contentPadding = navigationBarContentPadding(horizontal = 16.dp),
    ) {
        item {
            Text(
                text = "שינוי נכנס לתוקף בפעם הבאה שהמסך הרלוונטי נפתח. " +
                        "איפוס מוחק את הערך השמור ומחזיר לברירת המחדל.",
                modifier = Modifier.padding(vertical = 12.dp),
                style = MaterialTheme.typography.bodySmall,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
            )
        }

        states.groupBy { it.flag.group }.forEach { (group, groupStates) ->
            item(key = group.name) {
                Text(
                    text = group.title,
                    modifier = Modifier.padding(top = 16.dp, bottom = 4.dp),
                    style = MaterialTheme.typography.titleMedium,
                    color = MaterialTheme.colorScheme.primary,
                )
            }

            items(
                items = groupStates,
                key = { it.flag.key },
            ) { state ->
                DebugFlagRow(
                    state = state,
                    onValueChange = { value ->
                        repository.set(state.flag, value)
                        refresh()
                    },
                    onReset = {
                        repository.reset(state.flag)
                        refresh()
                    },
                )
                HorizontalDivider()
            }
        }
    }
}

@Composable
private fun DebugFlagRow(
    state: DebugFlagState,
    onValueChange: (Boolean) -> Unit,
    onReset: () -> Unit,
) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .testTag("debug_flag_${state.flag.key}")
            .padding(vertical = 4.dp),
        verticalAlignment = Alignment.CenterVertically,
    ) {
        Column(modifier = Modifier.weight(1f)) {
            Text(
                text = state.flag.key,
                modifier = Modifier.fillMaxWidth(),
                style = MaterialTheme.typography.bodyMedium.copy(
                    fontFamily = FontFamily.Monospace,
                    textDirection = TextDirection.Ltr,
                ),
            )
            Text(
                text = if (state.isStored) "שמור" else "ברירת מחדל",
                style = MaterialTheme.typography.bodySmall,
                color = if (state.isStored) {
                    MaterialTheme.colorScheme.primary
                } else {
                    MaterialTheme.colorScheme.onSurfaceVariant
                },
            )
        }

        IconButton(
            onClick = onReset,
            enabled = state.isStored,
        ) {
            Icon(
                imageVector = AppIcons.Restore,
                contentDescription = "איפוס לברירת מחדל",
            )
        }

        Switch(
            checked = state.value,
            onCheckedChange = onValueChange,
            colors = SwitchDefaults.colors(
                checkedTrackColor = colorResource(SharedRes.colors.colorAccent),
            ),
        )
    }
}
